/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injection volume scales with the column volume.`)
};

const es_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El volumen de inyección escala con el volumen de la columna.`)
};

const de_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Injektionsvolumen skaliert mit dem Säulenvolumen.`)
};

const nl_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injectievolume schaalt met het kolomvolume.`)
};

const fr_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le volume d'injection s'adapte au volume de la colonne.`)
};

const it_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il volume di iniezione scala con il volume della colonna.`)
};

const pt_br2_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de injeção escala com o volume da coluna.`)
};

const pt_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de injeção escala com o volume da coluna.`)
};

const ja_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注入量はカラム体積に比例します。`)
};

const zh_hplc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进样量随柱体积放大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_ex3", locale)
	if (locale === "en") return en_hplc_ex3(inputs)
	if (locale === "es") return es_hplc_ex3(inputs)
	if (locale === "de") return de_hplc_ex3(inputs)
	if (locale === "nl") return nl_hplc_ex3(inputs)
	if (locale === "fr") return fr_hplc_ex3(inputs)
	if (locale === "it") return it_hplc_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_ex3(inputs)
	if (locale === "pt") return pt_hplc_ex3(inputs)
	if (locale === "ja") return ja_hplc_ex3(inputs)
	return zh_hplc_ex3(inputs)
};